const tags =
['Freight',
  'Delay',
  'Loading',
  'Unloading',
  'Loading Detention',
  'UnLoading Detention',
  'Penalty',
  'LR',
  'Additional Point',
  'ODA',
  'Miscellaneous charge',
  'Shortage',
  'Damage',
  'Leakage',
  'Carton Damage',
  'SLA Delay',
  'Fixed Charge',
  'Total',
  'Transit Delay',
  'Transporter Rejection',
  'SLA Breach',
  'SLA Breach - Reassigned',
  'Open Debit',
  'RFQ Debit',
  'Contract Reindent',
  'Debit Adjustment'];

export default tags;
